export const config = {
  baseUrl: './',
  apiUrl: './api',
  // 其他配置项...
}

export const acceptImageFormats = '' //'jpg,png,webp'
